export const FormateDate = (date) => {
  const originalDate = new Date(date);
  const day = originalDate.getUTCDate().toString().padStart(2, "0");
  const month = (originalDate.getUTCMonth() + 1).toString().padStart(2, "0"); // Adding 1 because months are zero-based
  const year = originalDate.getFullYear();
  const formattedDate = `${day}-${month}-${year}`;
  return formattedDate;
};
export const DateToYYYYMMDD = (inputDate) => {
  const date = new Date(inputDate);
  const year = String(date.getFullYear()).padStart(4, '0');
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const formatDateTimetoAmPm = (dateString) => {
  if (!dateString) {
    return "---"
  }
  const date = new Date(dateString);
  // console.log(date.getTime())
  // if (isNaN(date.getTime())) {
  //   // throw new Error("Invalid date string");
  // }
  // Extract date components
  const year = String(date.getUTCFullYear()); // Last two digits of year
  const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Month is 0-indexed
  const day = String(date.getUTCDate()).padStart(2, '0');

  // Extract time components
  let hours = date.getUTCHours();
  const minutes = String(date.getUTCMinutes()).padStart(2, '0');

  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12; // The hour '0' should be '12'
  hours = String(hours).padStart(2, '0')
  // Format the date and time
  const formattedDate = `${day}-${month}-${year}`;
  const formattedTime = `${hours}:${minutes} ${ampm}`;

  return `${formattedDate} ${formattedTime}`;
}

export const extractDateTime = (dateTimeString) => {
  // Parse the date string into a Date object
  const date = new Date(dateTimeString);

  // Check if the Date object is valid
  if (isNaN(date.getTime())) {
    return "---"

    throw new Error("Invalid date string");
  }

  // Extract date components
  const year = String(date.getUTCFullYear());
  const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const day = String(date.getUTCDate()).padStart(2, '0');

  // Extract time components
  const hours24 = date.getUTCHours();
  const minutes = String(date.getUTCMinutes()).padStart(2, '0');

  // Convert 24-hour time to 12-hour format and determine AM/PM
  const period = hours24 >= 12 ? 'PM' : 'AM';
  const hours12 = (hours24 % 12) || 12; // Convert 0 hours to 12
  const formattedHours = String(hours12).padStart(2, '0');

  // Format the date and time components separately
  const formattedDate = `${day}-${month}-${year}`;
  const formattedTime = `${formattedHours}:${minutes} ${period}`;

  return { date: formattedDate, time: formattedTime };
};

export const formatTimeDuration = (duration) => {
  if (!duration) return "--";

  const parts = duration.split(" "); // Split the input string by space
  let days = 0,
    time = "00:00";
  console.log(duration, parts);

  // Extract days and time from the input string
  if (parts.length > 2) {
    days = parseInt(parts[0]);
    time = parts[2];
  } else if (parts.length === 1) {
    if (parts[0].includes(":")) {
      time = parts[0];
    } else {
      days = parseInt(parts[0]);
    }
  }

  // Split time into hours and minutes
  const [hours, minutes] = time.split(":").map(Number);

  // Construct the output based on the specified conditions
  if (days === 0 && hours === 0 && minutes === 0) {
    return "0 days 00:00";
  } else if (days === 0) {
    return ` ${hours < 10 ? "0" + hours : hours}:${minutes < 10 ? "0" + minutes : minutes
      } `;
  } else if (hours === 0 && minutes === 0) {
    return ` ${days} ${days === 1 ? "day" : "days"} `;
  } else {
    return ` ${days} ${days === 1 ? "day" : "days"} ${hours < 10 ? "0" + hours : hours
      }:${minutes < 10 ? "0" + minutes : minutes} `;
  }
}

export const convertToDateTimeLocalFormat = (dateString) => {
  const localDate = new Date(dateString);
  const offsetDate = new Date(localDate.getTime())
    .toISOString()
    .slice(0, 16);
  return offsetDate;
};